import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import TheHeader from "./components/layout/TheHeader.vue";
import BaseButton from "./components/UI/BaseButton.vue";
import BaseCard from './components/UI/BaseCard.vue';
import BaseBadge from './components/UI/BaseBadge.vue'
import GlobalCard from './components/UI/GlobalCard.vue'
import BaseModel from './components/UI/BaseModel.vue'
import BaseSpinner from './components/UI/BaseSpinner'

const app = createApp(App);

app.component("the-header", TheHeader);
app.component("base-button", BaseButton);
app.component("base-card", BaseCard);
app.component("base-badge", BaseBadge);
app.component("global-card", GlobalCard);
app.component("base-model", BaseModel);
app.component("base-spinner", BaseSpinner);

app.use(store);
app.use(router);
app.mount("#app");
